module.exports = __webpack_public_path__ + "img/next2.3aedf510.svg";